import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

import { logging, logPostInfo } from '../../../actions/log';
import styles from './ForumReview.module.less';
import CheckSoft from '../../../components/Forum/CheckSoft/CheckSoft';
import { byteLength, getQueryString } from '../../../utils/utils';
import { postForumAddReview, setShowForumReview, setLenovoSoft } from '../../../actions/forum';

import Toast from '../../../components/Toast/Toast';
import xss from 'xss';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectforumReviewShow = createSelector(
  state => state.forum,
  forum => forum.forumReviewShow,
);
const selectForumAddReview = createSelector(
  state => state.forum,
  forum => forum.forumAddReview,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

export default function ForumReview() {
  const dispatch = useDispatch();

  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);
  const forumAddReview = useSelector(selectForumAddReview);
  const comment = useSelector(selectforumReviewShow);

  const [checkSoftList, setCheckSoftList] = useState([]);
  const [value, setValue] = useState('');
  const [isNoValue, setIsNoValue] = useState(null);
  const [submitTime, setSubmitTime] = useState(+new Date());
  const [isSubmitLogin, setIsSubmitLogin] = useState(false);
  const [updateCheckSoft, setUpdateCheckSoft] = useState(false);

  const maxLength = 300;
  const id = getQueryString('id');

  useEffect(() => {
    return () => {
      dispatch(setLenovoSoft({ word: '', pageKey: 'review', data: {} }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (forumAddReview.submitTime === submitTime && !forumAddReview.loading) {
      dispatch(
        logging({
          category: 'R',
          action: 'Forum_Detail_Review_Result',
          label: '',
          param2: {
            source: 'Forum_Detail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id,
            commentId: forumAddReview.originalCommentId,
            reviewId: forumAddReview.bizId,
            status: forumAddReview.status,
          },
        }),
      );

      if (forumAddReview.submitTime === submitTime && forumAddReview.status === 0) {
        setValue('');
        setCheckSoftList([]);
        setIsNoValue(null);
        setUpdateCheckSoft(true);
        // setTimeout(() => {
        //   dispatch(setShowForumReview(null));
        //   dispatch(setLenovoSoft({ word: '', pageKey: 'review', data: {} }));
        //   setUpdateCheckSoft(false);
        // }, 20);
      }
    }
  }, [forumAddReview, comment, submitTime]);

  useEffect(() => {
    if (isSubmitLogin === true) {
      const login_status = window.CallNativeMethod('get_login_status');
      if (login_status === '1' && userInfo.st) {
        handleAddComment();
        setIsSubmitLogin(false);
      }
    }
  }, [userInfo, isSubmitLogin]);

  const handleAddComment = useCallback(() => {
    // 设置显示
    setIsNoValue(false);
    if (!value) {
      setIsNoValue(true);
      Toast.error({ content: '请输入评论内容！' });
      return;
    }

    // 验证字数
    if (byteLength(value) > maxLength) {
      Toast.error({ content: '输入内容超过最大字数！' });
      return;
    }

    // 获取用户是否登录
    const login_status = window.CallNativeMethod('get_login_status');
    if (login_status !== '1') {
      // 未登录，弹出登录框
      window.CallNativeMethod('login');
      setIsSubmitLogin(true);
      return;
    }

    const time = +new Date();
    setSubmitTime(time);

    dispatch(
      logging({
        category: 'C',
        action: 'Forum_Detail_Review_Submit',
        label: '',
        param2: {
          source: 'Forum_Detail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          passInfos: checkSoftList,
          id,
          commentId: comment.originalCommentId,
          reviewId: comment.id,
        },
      }),
    );
    dispatch(
      postForumAddReview({
        bizIdentity: comment.bizIdentity,
        content: encodeURIComponent(xss(`@${comment.userName}:${value}`)),
        originalCommentId: comment.originalCommentId === 0 ? comment.id : comment.originalCommentId,
        parentId: comment.id,
        grade: 5,
        passInfos: checkSoftList,
        type: '3',
        bizId: id,
        commentUserId: comment.userId,
        submitTime: time,
      }),
    );
  }, [comment, value, checkSoftList]);

  const handleChange = useCallback(ev => {
    ev.persist();
    const inputValue = ev.target.value;
    setValue(inputValue);
  });

  const handleFocus = useCallback(ev => {
    ev.persist();
    setIsNoValue(false);
  });

  const handleCancel = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Forum_Detail_Review_Close',
        label: '',
        param2: {
          source: 'Forum_Detail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          passInfos: checkSoftList,
          id,
          commentId: comment.originalCommentId,
          reviewId: comment.id,
        },
      }),
    );
    setIsNoValue(null);
    dispatch(setShowForumReview(null));
    dispatch(setLenovoSoft({ word: '', pageKey: 'review', data: {} }));
  }, [logInfoData, checkSoftList, comment]);

  return (
    comment &&
    comment.userId && (
      <div className={styles.mask}>
        <div className={styles.review}>
          <div className={styles.review_user}>
            回复 {comment.userName}
            <div className={`${styles.review_colse} iconfont icon-close`} onClick={handleCancel} />
          </div>
          <div className={styles.comment_textarea_box}>
            <textarea
              className={isNoValue === true ? styles.comment_textarea_red : styles.comment_textarea}
              placeholder={'这里是评论内容'}
              value={value}
              onChange={handleChange}
              onFocus={handleFocus}
            />
            <div className={styles.comment_textarea_num}>
              <span className={byteLength(value) > maxLength ? styles.textarea_num_max : ''}>
                {byteLength(value)}
              </span>
              <span> / {maxLength}</span>
            </div>
          </div>
          <div className={styles.comment_bottom}>
            <CheckSoft
              setCheckSoftList={setCheckSoftList}
              checkSoftList={checkSoftList}
              updateCheckSoft={updateCheckSoft}
              pageKey={'review'}
            />
            {value === '' ? (
              <div className={styles.comment_btn_}>发表</div>
            ) : (
              <div className={styles.comment_btn} onClick={handleAddComment}>
                发表
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
}
